const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const EnragedCondition = require('../../conditions/EnragedCondition');
const CCHandler = require('../../CCHandler');
const { logError } = require('../../logger');
const { getAbilityLevel } = require('../../../isomorphic-helpers');

const PsycheOut = function (battleState) {
  this.handle = 'psyche_out';
  this.magic = true;
  this.ranged = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.unit;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const reflected = BattleCalc.rollForReflectMagic(victim);
      const finalActor = reflected ? victim : actor;
      const finalVictim = reflected ? actor : victim;

      var alliesOfVictim = BattleCalc.getAlliesOfUnit(
        finalVictim,
        battleState.allUnits,
        false
      );
      var victims = [];

      for (let i = 0; i < alliesOfVictim.length; ++i) {
        var ally = alliesOfVictim[i];
        if (
          BattleCalc.boardDistance(finalVictim, ally) <= ability.effectRange
        ) {
          victims.push(ally);
        }
      }

      // sort the ally victims by willpower
      victims.sort((a, b) => {
        const aAtts = a.attributes;
        const aWP =
          aAtts.base.willpower +
          aAtts.fromUpgrades.willpower +
          aAtts.fromEquipment.willpower +
          aAtts.fromConditions.willpower;
        const bAtts = b.attributes;
        const bWP =
          bAtts.base.willpower +
          bAtts.fromUpgrades.willpower +
          bAtts.fromEquipment.willpower +
          bAtts.fromConditions.willpower;
        return aWP - bWP;
      });

      const ability_level = getAbilityLevel({
        ability_handle: ability.handle,
        unit_build: actor,
      });
      victims = victims.slice(0, ability_level - 1);
      victims.push(finalVictim); // guarantee the victim is included

      var enragedConditions = [];
      for (let i = 0; i < victims.length; ++i) {
        if (!CCHandler.checkForResistRage(victims[i], battleState)) {
          var instigator = getRageInstigator();
          var enraged = new EnragedCondition(
            instigator,
            victims[i],
            battleState,
            ability.duration
          );
          enraged.instigatorId = instigator.uid;
          enraged.ownerId = victims[i].uid;
          battleState.onUnitCondition(enraged);
          enragedConditions.push(enraged);
        }
      }

      function getRageInstigator() {
        var unitsArray = [];
        for (var prop in battleState.allUnits) {
          unitsArray.push(battleState.allUnits[prop]);
        }

        return unitsArray[Math.floor(Math.random() * unitsArray.length)];
      }

      var result = { enragedConditions };
      result.abilityHandle = this.handle;
      result.actorId = finalActor.uid;
      result.victimId = finalVictim ? finalVictim.uid : null;
      result.is_reflection = reflected;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'PsycheOut',
        func: 'execute',
        actor: JSON.stringify(actor),
        victim: JSON.stringify(victim),
      });
      return { success: false };
    }
  };
};
module.exports = PsycheOut;
